<template>
  <div>
    <div v-if="loading" class="mt-5 mb-5">
      <spinner position="center"></spinner>
    </div>
    <form
      v-if="client"
      v-show="!loading"
      id="obligationsForm"
      ref="obligationsForm"
      method="POST"
      class="ang-card-body"
      :action="action"
    >
      <input
        name="finished"
        value="1"
        type="hidden"
        v-if="client.survey_type !== 1"
      />
      <input type="hidden" name="code" :value="code" />
      <input type="hidden" name="data[step_3]" value="1" />
      <input
        v-if="
          !client.data.obligations ||
          client.data.obligations.length === 0 ||
          !client.data.obligations[0]
        "
        type="hidden"
        name="data[obligations][]"
      />
      <template v-if="client.data.obligations && client.data.obligations[0]">
        <div
          v-for="(e, i) in client.data.obligations"
          :key="'obligations_' + i"
        >
          <div class="row">
            <div class="col-12 d-flex">
              <div class="ang-card-title mt-3">
                Zobowiązanie<span
                  class="ml-2"
                  v-if="client.data.obligations.length > 1"
                  >({{ i + 1 }})</span
                >
              </div>
              <div class="ml-auto">
                <button
                  class="mt-3 btn btn-lg ang-button _bg_color1"
                  @click.stop.prevent="removeObligation(i)"
                >
                  Usuń
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Typ zobowiązania</label>
                <select-field
                  :name="'data[obligations][' + i + '][type]'"
                  css="width: 100%"
                  :required="!is_expert"
                  :options="obligationTypes"
                  placeholder="Wybierz"
                  @changed="clearSelects"
                  v-model="e.type"
                  :selected="e.type"
                ></select-field>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Charakter zobowiązania</label>
                <select-field
                  :name="'data[obligations][' + i + '][char]'"
                  css="width: 100%"
                  @changed="refreshForm"
                  :options="{
                    values: [
                      { text: 'Prywatne', val: 'Prywatne' },
                      { text: 'Firmowe', val: 'Firmowe' },
                    ],
                  }"
                  placeholder="Wybierz"
                  v-model="e.char"
                  :selected="e.char"
                ></select-field>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Nazwa banku</label>
                <select-field
                  :name="'data[obligations][' + i + '][bank]'"
                  css="width: 100%"
                  :options="bankNames"
                  placeholder="Wybierz"
                  @changed="refreshForm"
                  :search="true"
                  v-model="e.bank"
                  :selected="e.bank"
                ></select-field>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Data zawarcia umowy</label>
                <input
                  type="text"
                  class="ang-form-control datepicker dateBeforeNow"
                  :name="'data[obligations][' + i + '][date_from]'"
                  v-model="e.date_from"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Data wygaśnięcia umowy</label>
                <input
                  type="text"
                  class="ang-form-control datepicker dateAfterNow"
                  :name="'data[obligations][' + i + '][date_to]'"
                  :disabled="
                    e.type === 'Karta kredytowa' ||
                    e.type === 'Limit w koncie osobistym'
                  "
                  v-model="e.date_to"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label
                  class="ang-form-label"
                  v-if="
                    e.type === 'Karta kredytowa' ||
                    e.type === 'Limit w koncie osobistym'
                  "
                  >Wysokość limitu (PLN)</label
                >
                <label
                  class="ang-form-label"
                  v-else-if="
                    e.type === 'Kredyt gotówkowy/ratalny' &&
                    e.type === 'Kredyt hipoteczny'
                  "
                  >Kwota kredytu (PLN)</label
                >
                <label class="ang-form-label" v-else
                  >Kwota zobowiązania (PLN)</label
                >
                <currency-field
                  :name="'data[obligations][' + i + '][amount]'"
                  v-model="e.amount"
                  :notrequired="true"
                ></currency-field>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Pozostało do spłaty (PLN)</label>
                <currency-field
                  :name="'data[obligations][' + i + '][remaining_amount]'"
                  :disabled="
                    e.type === 'Karta kredytowa' ||
                    e.type === 'Limit w koncie osobistym'
                  "
                  v-model="e.remaining_amount"
                  :notrequired="true"
                ></currency-field>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <label class="ang-form-label">Wysokość raty (PLN)</label>
                <currency-field
                  :name="'data[obligations][' + i + '][installment]'"
                  :disabled="
                    e.type === 'Karta kredytowa' ||
                    e.type === 'Limit w koncie osobistym'
                  "
                  v-model="e.installment"
                  :notrequired="true"
                ></currency-field>
              </div>
            </div>
            <div class="col-12 col-md-4" v-show="e.type === 'Inne'">
              <div class="form-group">
                <label class="ang-form-label"
                  >Doprecyzuj typ zobowiązania</label
                >
                <input
                  type="text"
                  class="ang-form-control"
                  :name="'data[obligations][' + i + '][type_description]'"
                  v-model="e.type_description"
                />
              </div>
            </div>
            <div class="col-12 col-md-4" v-show="e.bank === 'Inny'">
              <div class="form-group">
                <label class="ang-form-label">Doprecyzuj nazwę banku</label>
                <input
                  type="text"
                  class="ang-form-control"
                  :name="'data[obligations][' + i + '][bank_description]'"
                  v-model="e.bank_description"
                />
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group" v-if="coclients.length > 0">
                <label class="ang-form-label"
                  >Powiązane z drugim wnioskodawcą?</label
                >
                <select-field
                  :name="'data[obligations][' + i + '][connected][]'"
                  css="width: 100%"
                  :options="{ values: coclients }"
                  placeholder="Wybierz"
                  :multi="true"
                  @changed="refreshForm"
                  :selected="e.connected"
                ></select-field>
              </div>
            </div>
            <!--                        <div class="col-6 col-md-2">-->
            <!--                            <div class="form-group">-->
            <!--                                <label class="ang-form-label">Waluta</label>-->
            <!--                                <input type="text" class="ang-form-control" :name="'data[obligations][' + i + '][currency]'" :disabled="e.type === 'Karta kredytowa' || e.type === 'Limit w koncie osobistym'"-->
            <!--                                       v-model="e.currency">-->
            <!--                            </div>-->
            <!--                        </div>-->
          </div>
        </div>
      </template>
      <div class="alert alert-danger ang-alert-danger mt-3" v-if="error">
        <h5 class="ang-card-title">Wystąpił błąd!</h5>
        <label class="form-error error">{{ error }}</label>
      </div>

      <div class="d-flex">
        <div>
          <button
            class="btn ang-button _bg_color3 mt-1"
            @click.stop.prevent="$emit('backward')"
          >
            Wstecz
          </button>
        </div>
        <div class="ml-auto">
          <spinner v-if="sending"></spinner>
          <div v-else>
            <button
              class="btn btn-lg ang-button _bg_color2 spinn mr-2"
              @click.stop.prevent="addObligation"
            >
              <span
                v-if="
                  !client.data.obligations ||
                  client.data.obligations.length === 0
                "
                >Dodaj zobowiązanie</span
              ><span v-else>Dodaj kolejne zobowiązanie</span>
            </button>
            <button
              type="submit"
              class="btn btn-lg ang-button ang-btn-lg spinn"
            >
              Zapisz i przejdź dalej
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ajax from "@/services/ajax";
// import api from '@/services/api'
import spinner from "@/components/partials/misc/spinner";
import select from "@/components/partials/misc/select";
import currency from "@/components/partials/misc/currency";
import moment from "moment";
import $ from "jquery";

export default {
  data() {
    return {
      success: false,
      error: null,
      sending: false,
      coclients: [],
      loading: true,
      client: null,
      obligationTypes: {
        values: [
          { text: "Kredyt hipoteczny", val: "Kredyt hipoteczny" },
          { text: "Kredyt gotówkowy/ratalny", val: "Kredyt gotówkowy/ratalny" },
          { text: "Limit w koncie osobistym", val: "Limit w koncie osobistym" },
          { text: "Karta kredytowa", val: "Karta kredytowa" },
          { text: "Leasing", val: "Leasing" },
          { text: "Inne", val: "Inne" },
        ],
      },
      bankNames: {
        values: [
          { text: "Alior Bank", val: "Alior Bank" },
          {
            text: "BOŚ (Bank Ochrony Środowiska)",
            val: "BOŚ (Bank Ochrony Środowiska)",
          },
          {
            text: "BPS (Bank Polskiej Spółdzielczości)",
            val: "BPS (Bank Polskiej Spółdzielczości)",
          },
          { text: "Bank Pocztowy", val: "Bank Pocztowy" },
          { text: "BNP Paribas", val: "BNP Paribas" },
          { text: "Citi Handlowy", val: "Citi Handlowy" },
          { text: "Credit Agricole", val: "Credit Agricole" },
          { text: "Deutsche Bank Polska", val: "Deutsche Bank Polska" },
          { text: "DNB Bank Polska", val: "DNB Bank Polska" },
          { text: "Envelobank", val: "Envelobank" },
          { text: "Getin Noble Bank", val: "Getin Noble Bank" },
          { text: "HSBC Bank Polska", val: "HSBC Bank Polska" },
          { text: "Idea Bank", val: "Idea Bank" },
          { text: "ING Bank Śląski", val: "ING Bank Śląski" },
          { text: "Inteligo", val: "Inteligo" },
          { text: "Lions Bank", val: "Lions Bank" },
          { text: "mBank", val: "mBank" },
          { text: "Millennium", val: "Millennium" },
          { text: "Nest Bank", val: "Nest Bank" },
          { text: "Orange Finanse", val: "Orange Finanse" },
          { text: "Pekao SA", val: "Pekao SA" },
          { text: "Plus Bank", val: "Plus Bank" },
          { text: "PKO BP", val: "PKO BP" },
          { text: "Raiffeisen Polbank", val: "Raiffeisen Polbank" },
          { text: "Santander Bank Polska", val: "Santander Bank Polska" },
          { text: "Standard Chartered", val: "Standard Chartered" },
          { text: "T-Mobile Usługi Bankowe", val: "T-Mobile Usługi Bankowe" },
          { text: "Toyota Bank", val: "Toyota Bank" },
          { text: "VeloBank", val: "VeloBank" },
          { text: "Volkswagen Bank Polska", val: "Volkswagen Bank Polska" },
          { text: "Revolut", val: "Revolut" },
          { text: "Inny", val: "Inny" },
        ],
      },
    };
  },
  props: ["base_client", "base", "code", "is_expert"],
  components: {
    spinner,
    "select-field": select,
    "currency-field": currency,
  },
  watch: {
    base_client() {
      let self = this;
      this.client = this.base_client;
      for (let i = 0; i < this.client.coclients.length; i++) {
        if (this.client.coclients[i].val) {
          this.coclients.push({
            val: this.client.coclients[i].val,
            text: this.client.coclients[i].name,
          });
        }
      }
      this.$nextTick(function () {
        self.loading = false;
      });
    },
  },
  name: "obligationsForm",
  computed: {
    action() {
      return "/client/details/" + this.base;
    },
  },
  mounted() {
    let self = this;
    this.client = this.base_client;
    for (let i = 0; i < this.client.coclients.length; i++) {
      if (this.client.coclients[i].val) {
        this.coclients.push({
          val: this.client.coclients[i].val,
          text: this.client.coclients[i].name,
        });
      }
    }
    for (let i = 0; i < this.client.data.obligations.length; i++) {
      this.client.data.obligations.date_from = this.parseDate(
        this.client.data.obligations.date_from,
      );
      this.client.data.obligations.date_to = this.parseDate(
        this.client.data.obligations.date_to,
      );
    }
    this.$nextTick(function () {
      self.loading = false;
      ajax.postValidate(
        $(self.$refs.obligationsForm),
        self,
        function () {
          self.sending = false;
          self.$emit("forward", self.client);
        },
        function (data) {
          self.error = data.message;
          self.sending = false;
          $("html,body").animate({ scrollTop: $(document).height() }, "slow");
        },
        function () {
          self.error = null;
          self.sending = true;
        },
      );
      self.datepickers();
    });
  },
  methods: {
    parseDate(dateString) {
      if (
        dateString &&
        dateString.length > 4 &&
        moment(dateString, "YYYY-MM-DD", true).isValid()
      ) {
        return moment(dateString).format("DD-MM-YYYY");
      }
      return dateString;
    },
    refreshForm() {
      this.$forceUpdate();
    },
    addObligation() {
      if (typeof this.client.data.obligations === "undefined") {
        this.client.data.obligations = [];
      }
      this.client.data.obligations.push({});
      this.$forceUpdate();
      this.datepickers();
    },
    datepickers() {
      this.$nextTick(function () {
        $(".datepicker")
          .datetimepicker({
            locale: "pl",
            format: "DD-MM-YYYY",
          })
          .on("change", function () {
            $(this).valid();
          })
          .unbind("change")
          .unbind("dp.change")
          .on("dp.change", function (e) {
            let event = document.createEvent("HTMLEvents");
            event.initEvent("input", true, true);
            e.currentTarget.dispatchEvent(event);
            $(this).trigger("change");
            $(this).valid();
          });
      });
    },
    removeObligation(i) {
      this.client.data.obligations.splice(i, 1);
      this.$forceUpdate();
    },
    clearSelects() {
      $(".select2").each(function () {
        if (
          typeof $(this) === "object" &&
          typeof $(this).prev() === "object" &&
          $(this).prev().prop("nodeName") !== "SELECT"
        ) {
          $(this).remove();
        }
      });
      // this.datepickers()
      this.$forceUpdate();
    },
    scrollToAnchor(aid) {
      let aTag = $("#" + aid);
      if (typeof aTag !== "undefined" && typeof aTag.offset() !== "undefined") {
        $("html,body").animate({ scrollTop: aTag.offset().top - 160 }, "slow");
      }
    },
  },
};
</script>
